import TIMESTAMPS from './timestamps.json';

/* eslint-disable import/no-mutable-exports */
let authTokenInterval;
let authModalInterval;
/* eslint-enable import/no-mutable-exports */

export { authModalInterval, authTokenInterval };

export default function sessionTimestampManager({ onShowModal, onLogout }) {
  return {
    reset: (isLoggedIn = true) => {
      if (authTokenInterval) {
        clearInterval(authTokenInterval);
      }

      if (authModalInterval) {
        clearInterval(authModalInterval);
      }

      if (isLoggedIn) {
        authModalInterval = window.setInterval(
          () => {
            clearInterval(authModalInterval);

            onShowModal(authTokenInterval);
          },
          TIMESTAMPS.MODAL
        );

        authTokenInterval = window.setInterval(
          () => {
            clearInterval(authModalInterval);
            clearInterval(authTokenInterval);

            onLogout();
          },
          TIMESTAMPS.LOGOUT
        );
      }
    },
  };
}
